module.exports = __webpack_public_path__ + "img/image44.b57e0321.jpg";